import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';

import {CommunicationService} from '../communication.service';
import {LocalStorageService} from '../local-storage.service';
import {MessageCount} from '../../domains/common.domain';

@Injectable()

export class NotificationsService {
  onViewNotification: Subject<any>;

  currentUrl: string;

  constructor(
    private communicationService: CommunicationService,
    private localStorageService: LocalStorageService,
    private router: Router,
  ) {
    this.currentUrl = document.location.href;
    this.onViewNotification = new Subject<any>();

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  notifyOnViewNotification(): void {
    const userData = this.getUserData();
    if (userData.technicianId && userData.role === 'employee') {
      this.router.navigate(['/employee-overview']);
      setTimeout(() => {
        const dataObject = {
          role: userData.role,
        };
        this.onViewNotification.next(dataObject);
      });
    } else {
      this.router.navigate(['/messages']);
    }
  }

  registerForViewNotification(): Subject<any> {
    return this.onViewNotification;
  }

  getNotificationCount(): Observable<MessageCount> {
    return this.communicationService.getData('message?count=1&message_read=0');
  }

  getUserData(): {
    role: string;
    technicianId: string;
  } {
    const technicianId = this.localStorageService.getItem('technician_id');
    const role = this.localStorageService.getItem('role');

    return {role, technicianId};
  }
}
